// extracted by mini-css-extract-plugin
module.exports = {"tags":"styles-module__tags___2LNU4","smallTags":"styles-module__smallTags___1xyq1","tag":"styles-module__tag___3BCuI"};